export default {
  "user.createUser": "ユーザーID",
  "user.createAccount": "アカウント作成",
  "user.emailError": "メールエラー",
  "user.accountChangeStates": "有効/無効",
  "user.passwordAgain": "パスワード確認",
  "user.mobileNum": "電話番号",
  "user.role": "役割",
  "user.plsSelectRoleAuth": "役割の許可を選択してください",
  "user.roleAuthorization": "権限",
  "user.plsSelectRoleAuthorization": "権限を選択してください",
  "user.personalStamp": "個人印画像",
  "user.checkIt": "確認してください",
  "user.oldpassword": "バスワード（旧）",
  "user.oldpassword.plsInput": "バスワード（旧）を入力してください",
  "user.newpassword": "バスワード（新）",
  "user.newpassword.plsInput": "バスワード（新）を入力してください",
  "user.newpassword.confirm": "バスワード確認（新）",
  "user.newpassword.confirm.plsInput": "バスワード確認（新）を入力してください",
  "user.confirmResetPw": "パスワード変更の確認",
};